import React from 'react'
import PropTypes from 'prop-types'

import { BodyCopy } from 'components/ui/Typography'
import { getBriefParagraphs, hasBrief, isRichTextBrief, renderBrief } from './briefUtils'

const BriefContent = ({ content, multiline = false }) => {
  if (!hasBrief(content)) return null

  if (isRichTextBrief(content)) {
    return <BodyCopy as="div">{renderBrief(content)}</BodyCopy>
  }

  if (multiline) {
    return (
      <BodyCopy as="div">
        {getBriefParagraphs(content).map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </BodyCopy>
    )
  }

  return <BodyCopy>{content}</BodyCopy>
}

BriefContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  multiline: PropTypes.bool,
}

export default BriefContent
